import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router } from 'react-router-dom';
import performanceMonitor from './utils/PerformanceMonitor';

// Initialize performance monitoring
performanceMonitor.init();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
    <App />
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals((metric) => {
  // Enhanced reporting with performance monitor
  console.log('Web Vital:', metric);
  
  // Generate full performance report every 30 seconds
  if (Math.random() < 0.1) { // 10% sampling rate
    setTimeout(() => {
      performanceMonitor.generateReport();
    }, 30000);
  }
});
